import {ImageProps} from '@yosmanyga/primitive-ui-spec'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {InteractFn, SpacialFn, styled, VisualFn} from '@yosmanyga/web-style'

const Image = ({
    source,
    alt,
    className,
}: ImageProps & UnnormalizedStyleProps) => {
    return <img
        src={source as string}
        alt={alt}
        className={className}
    />
}

const StyledImage = styled(Image)`
    ${({align}) => SpacialFn.compileAlign(align)}
    ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
    ${({width}) => SpacialFn.compileWidth(SpacialFn.normalizeWidth(width))}
    ${({height}) => SpacialFn.compileHeight(SpacialFn.normalizeHeight(height))}

    ${({border}) => VisualFn.compileBorder(VisualFn.normalizeBorder(border))}
    ${({fit}) => VisualFn.compileFit(fit)}

    ${({cursor}) => InteractFn.compileCursor(cursor)}
` as typeof Image

export default StyledImage
